// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1evwU","question":"styles_question__1gS1d","description":"styles_description__1zC3v"};